//#region src/types/status.ts
let SystemStatus = /* @__PURE__ */ function(SystemStatus$1) {
	SystemStatus$1["Operational"] = "operational";
	SystemStatus$1["DegradedPerformance"] = "degraded_performance";
	SystemStatus$1["PartialOutage"] = "partial_outage";
	SystemStatus$1["MajorOutage"] = "major_outage";
	SystemStatus$1["UnderMaintenance"] = "under_maintenance";
	return SystemStatus$1;
}({});

//#endregion
export { SystemStatus as t };